let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    if (this.hasBeenInitialised) {
      this.setupListeners()
      return
    }

    super.connectedCallback()

    if (mobileMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=mobile-menu`,
      )
      .then((res) => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )
        const myself = newDOM.querySelector('mobile-menu')
        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    this.handleDrawerChange = this.handleDrawerChange.bind(this)

    this.listeners.add(document, 'drawer-changed', this.handleDrawerChange)

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleBack = this.handleBack.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
    this.listeners.add(this, 'click', this.handleBack)
  }

  getMatchedSubmenu (triggerEl) {
    if (!this.els.submenu?.exists || !this.els.submenu?.elements?.length) {
      return null
    }

    return this.els.submenu.elements.find(
      (submenuEl) =>
        submenuEl.dataset.handle === triggerEl.dataset.handle &&
        submenuEl.dataset.level === triggerEl.dataset.level &&
        submenuEl.dataset.topNavHandle === triggerEl.dataset.topNavHandle,
    )
  }

  syncTriggerExpandedState (triggerEl, isExpanded) {
    triggerEl.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')
  }

  handleTrigger (event) {
    if (!this.els.trigger?.exists) return

    const clickedTrigger = event.target.closest(this.els.trigger.selector)

    if (!clickedTrigger) return

    const matchedSubMenu = this.getMatchedSubmenu(clickedTrigger)

    if (!matchedSubMenu) return

    this.syncTriggerExpandedState(clickedTrigger, true)
    matchedSubMenu.classList.add('drw-Drawer-active')
    matchedSubMenu.showModal()
  }

  handleBack (event) {
    if (!this.els.back?.exists) return

    const backButtonEl = event.target.closest(this.els.back.selector)

    if (!backButtonEl) return

    const submenuEl = event.target.closest(this.els.submenu.selector)

    if (!submenuEl) return

    if (!this.els.trigger?.exists || !this.els.trigger?.elements?.length) {
      submenuEl.classList.remove('drw-Drawer-active')
      submenuEl.close()
      return
    }

    this.els.trigger.elements.forEach((triggerEl) => {
      const matchedSubmenuEl = this.getMatchedSubmenu(triggerEl)

      if (matchedSubmenuEl === submenuEl) {
        this.syncTriggerExpandedState(triggerEl, false)
      }
    })

    submenuEl.classList.remove('drw-Drawer-active')
    submenuEl.close()
  }

  handleDrawerChange () {
    if (this.els.trigger?.exists && this.els.trigger?.elements?.length) {
      this.els.trigger.elements.forEach((triggerEl) => {
        this.syncTriggerExpandedState(triggerEl, false)
      })
    }

    if (!this.els.submenu?.exists || !this.els.submenu?.elements?.length) {
      return
    }

    this.els.submenu.elements.forEach((submenuEl) => {
      submenuEl.classList.remove('drw-Drawer-active')
      submenuEl.close()
    })
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
